var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPokerstarsMobileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 138",
    width: 42,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.378 28.701C69.057 11.411 58.022.687 58.022.687S46.965 11.411 29.675 28.701C20.538 37.827 0 60.471 0 82.986c0 15.008 12.171 27.177 27.181 27.177 9.853 0 18.454-5.251 23.218-13.098v.008c.48-.586 1.263-1.066 2.143-1.066 1.399 0 2.671.986 2.524 2.208-1.047 8.097-5.606 28.046-23.573 34.785h53.044c-17.964-6.739-22.521-26.688-23.561-34.785-.156-1.222 1.127-2.208 2.524-2.208.861 0 1.654.48 2.134 1.066l.011-.008c4.744 7.847 13.354 13.098 23.206 13.098 15.002 0 27.182-12.169 27.182-27.177 0-22.515-20.538-45.159-29.655-54.285",
    id: "Fill-12",
    fill: "#D70022"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fill: "#FFFFFE",
    d: "M58.021 28.748l7.36 22.681h23.855L69.937 65.451l7.379 22.679-19.295-14.021L38.727 88.13l7.368-22.679-19.306-14.022h23.873l7.359-22.681"
  })));
}
SvgPokerstarsMobileLogo.displayName = 'PokerstarsMobileLogo';
export default SvgPokerstarsMobileLogo;